import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { NavigationState } from './types';

const initialState: NavigationState = {
  expandedItems: { DASHBOARD: true },
  activeItem: null,
  isCollapsed: false
};

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    toggleItem: (state, action: PayloadAction<string>) => {
      const code = action.payload;
      state.expandedItems[code] = !state.expandedItems[code];
    },

    expandItem: (state, action: PayloadAction<string>) => {
      state.expandedItems[action.payload] = true;
    },

    collapseItem: (state, action: PayloadAction<string>) => {
      state.expandedItems[action.payload] = false;
    },

    expandAll: (state, action: PayloadAction<string[]>) => {
      action.payload.forEach((code) => {
        state.expandedItems[code] = true;
      });
    },

    collapseAll: (state) => {
      Object.keys(state.expandedItems).forEach((key) => {
        state.expandedItems[key] = false;
      });
    },

    setActiveItem: (state, action: PayloadAction<string | null>) => {
      state.activeItem = action.payload;
    },

    toggleSidebar: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },

    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isCollapsed = action.payload;
    }
  }
});

export const {
  toggleItem,
  expandItem,
  collapseItem,
  expandAll,
  collapseAll,
  setActiveItem,
  toggleSidebar,
  setSidebarCollapsed
} = navigationSlice.actions;

export default navigationSlice.reducer;
